<template>
  <div :class="{wrap: true, 'sub-wrap': isSubscriber, 'no-sub-wrap': !isSubscriber}">
    <div class="search">
      <p>
        수진자명<input type="text" v-model="name" class="search-name">
      </p>
        <p>
          고객번호 <input type="number" v-model="chartNum" class="chart-num-input">
      </p>
          <p v-if="isSubscriber">
            조회날짜 <datepicker class="date-picker" calendar-class='date-picker-work-calendar' input-class='date-picker-list-input' :language='ko' format="yyyy-MM-dd" v-model="date"></datepicker>
          </p>
          <button class="search-btn" @click="onSearch">조회</button>
          <button class="search-all-btn" @click="onSearchAll">전체조회</button> <img src="@/assets/refresh.png" alt="refresh" @click="refreshData">
    </div>
          <div class="tip" v-if="isSubscriber">전체 조회를 누르시면 조회날짜에 해당하는 모든 예약자를 조회할수있습니다.</div>
          <div class="tip" v-else>이름을 선택하시면 해당 고객의 검사 현황을 확인 할 수 있습니다.</div>
    </div>
</template>

<script>
import dayJs from 'dayjs'
import Datepicker from 'vuejs-datepicker'
import { ko } from 'vuejs-datepicker/dist/locale'
export default {
  props: ['isSubscriber', 'todayDate'],
  data () {
    return {
      name: '',
      chartNum: '',
      date: '',
      ko
    }
  },
  created () {
    this.date = this.todayDate
  },
  methods: {
    onSearch () {
      this.$emit('onSearch', this.name, this.chartNum, this.formatDate)
    },
    onSearchAll () {
      this.$emit('onSearchAll', this.formatDate)
    },
    refreshData () {
      this.$emit('refreshData', this.formatDate)
    }
  },
  components: {
    Datepicker
  },
  computed: {
    formatDate () {
      return dayJs(this.date).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped lang='scss'>
.wrap {
  height: 125px;
  .search > p {
    display: inline-block;
    &:first-of-type {
      margin-right: 3vw;
    }
    // &:nth-of-type(2) {
    //   width: 280px;
    // }
    // &:nth-of-type(3) {
    //   width: 280px;
    // }
    // width: 300px;
  }
}
.search {
  position: relative;
  top: 2vh;
  float: left;
  left: 1.5vw;
  width: 85.5vw;
  height: 80px;
  background: #6982b3;
  line-height: 85px;
  padding: 0px 20px;
  font-size: 28px;
  color: white;

  input {
    height: 32px;
    position: relative;
    padding: 3px 10px;
    font-size: 1.1rem;
    bottom: 3px;
    width: 160px;
  }
}

.search .search-name {
  margin-left: 1vw;
  width: 120px;
}
.chart-num-input {
  margin-left: 1vw;
}
.search-btn {
  margin-left: 3vw;
  width: 75px;
  background-color: #f39800;
}

.search-all-btn {
  margin-left: 10px;
  margin-bottom: 1px;
  width: 120px;
  background-color: #00a0e9;
}

.search-btn,
.search-all-btn {
  font-size: 24px;
  border: transparent;
  height: 45px;
  line-height: 45px;
  color: white;
  position: relative;
  bottom: 4px;
}

img {
  float: right;
  display: block;
  margin: 7px 18px 0px 0px;
  width: 50px;
}

.tip {
  float: left;
  position: relative;
  top: 20px;
  left: 40px;
}
.sub-wrap {
  .search {
    padding: 0px 5px;
    > p:first-of-type {
      margin-right: 0px !important;
    }
    .search-name {
      bottom: 4px;
    }
  }
  .search-name {
    width: 100px;
    margin-right: 1vw;
  }
  .chart-num-input {
    width: 145px;
    margin-right: 1vw;
  }
  .date-input {
    width: 155px;
    margin-left: 1vw;
    padding: 3px 0px 3px 5px;
  }
  .search-btn {
    width: 65px;
    margin-left: 1vw;
  }
  .search-all-btn {
    width: 100px;
  }
}
@media screen and (min-width: 1501px) {
  .sub-wrap .date-input {
    width: 190px;
  }
}
@media screen and (min-width: 1300px) {
  .tip {
    top: 23px;
  }
}

@media screen and (max-width: 1230px) {
  .search {
    > p:first-child {
      margin-right: 2vw;
    }
    // background-color: red;
    img {
      margin-right: 0px;
    }
  }
  .search-btn {
    margin-left: 2vw;
    width: 65px;
  }
  .search-all-btn {
    width: 110px;
  }
  .search-btn,
  .search-all-btn {
    position: relative;
    bottom: 6px;
    font-size: 22px;
  }
  .sub-wrap {
    .search-btn,
    .search-all-btn {
      bottom: 10px;
    }
    .search {
      padding: 0px 40px;
      line-height: normal;
      font-size: 22px;
      > p {
        position: relative;
        top: 8px;
        &:first-child {
          width: 120px;
          position: relative;
          bottom: 4px;
        }
        &:nth-child(2) {
          width: 160px;
        }
        &:nth-child(3) {
          width: 250px;
          position: relative;
          top: -10px;
        }
        input {
          margin-left: 0px;
          margin-top: 10px;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .no-sub-wrap {
    .search > p {
      display: inline-block;
      &:first-of-type {
        width: 220px;
      }
      &:nth-of-type(2) {
        width: 245px;
      }
      &:nth-of-type(3) {
        width: 280px;
      }
    }
  }
  .search {
    font-size: 24px;
    input {
      width: 140px;
      height: 27px;
      bottom: 5px;
    }
    .search-btn,
    .search-all-btn {
      bottom: 3px;
    }
  }

  .sub-wrap {
    .search-btn,
    .search-all-btn {
      bottom: 7px;
    }
    .search .search-name {
      bottom: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Search.vue